"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const sizeNone = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-none',
    fallback: '0px'
});
const sizeXXS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-xxs',
    fallback: '2px'
});
const sizeXS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-xs',
    fallback: '4px'
});
const sizeS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-s',
    fallback: '8px'
});
const sizeM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-m',
    fallback: '16px'
});
const sizeL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-l',
    fallback: '24px'
});
const sizeXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-xl',
    fallback: '32px'
});
const sizeXXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-xxl',
    fallback: '48px'
});
const sizeXXXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'size-xxxl',
    fallback: '64px'
});
exports.sizeTokens = {
    sizeNone,
    sizeXXS,
    sizeXS,
    sizeS,
    sizeM,
    sizeL,
    sizeXL,
    sizeXXL,
    sizeXXXL
};
//# sourceMappingURL=Size.js.map